import { render, staticRenderFns } from "./Recoding.vue?vue&type=template&id=39138dc3&scoped=true&"
import script from "./Recoding.vue?vue&type=script&lang=js&"
export * from "./Recoding.vue?vue&type=script&lang=js&"
import style0 from "./Recoding.vue?vue&type=style&index=0&id=39138dc3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39138dc3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
